// extracted by mini-css-extract-plugin
module.exports = {"tab_info":"tabinfo_tab_info__LRam6"};